var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-tabs',{attrs:{"type":"border-card"},on:{"tab-click":_vm.handleClick},model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},[_c('el-tab-pane',{attrs:{"label":"腾讯有数参数配置","name":"youshu"}},[_c('youshu')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }